import { render, staticRenderFns } from "./Profil-day.vue?vue&type=template&id=628e1546&scoped=true&"
import script from "./Profil-day.vue?vue&type=script&lang=js&"
export * from "./Profil-day.vue?vue&type=script&lang=js&"
import style0 from "./Profil-day.vue?vue&type=style&index=0&id=628e1546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628e1546",
  null
  
)

export default component.exports